module.exports = __webpack_public_path__ + "assets/static/media/hireprivyMobileInfo.7b6ae2d7.png";